<!--
 * @Date: 2022-08-03 14:26:09
 * @LastEditTime: 2022-08-15 19:06:21
 * @FilePath: /vue-medweb/packages/vue-m-comprehensive/src/views/PhysicianDay/index.vue
 * @Description: 医师节活动
-->
<template>
  <div class="physician-day-wrap">
    <!-- 头图 -->
    <div class="web-banner">
      <img :src="topImage" alt="" />
    </div>

    <!-- 视频区域 -->
    <Video
      :play-image="playImage"
      :video-url="playUrl"
      @playVideo="playVideo"
    />

    <!-- 投票区 -->
    <div class="vote-wrap" @click.stop="doActivityClick('投票模块', voteUrl)">
      <img :src="voteImage" alt="" />
    </div>

    <!-- 弹幕区 -->
    <div class="barrage-wrap">
      <Barrage :thanks-list="thankWordsList" />
      <div class="input-wrap">
        <input
          v-model="thankMessage"
          type="text"
          maxlength="200"
          placeholder="给帮助过你的医生，送上最真挚的感谢"
        />
        <div class="bs-btn" @click="clickSendBtn">发表</div>
      </div>
    </div>

    <!-- 直播预约区域 -->
    <div
      class="subscribe-live-wrap"
      @click.stop="doActivityClick('直播模块', appointmentUrl)"
    >
      <img :src="appointmentImage" alt="" />
    </div>

    <!-- 致辞 -->
    <div class="speech-wrap">
      <img :src="speechImage" alt="" />
    </div>

    <div class="logo" />
  </div>
</template>

<script>
import {
  doctorsDayPatientPageDetail,
  doctorsDaySendThankWords,
  isLogin,
} from '@/services/index';
import cyShare from '@cy/share';
import * as cyDetect from '@cy/detect';
import Barrage from '@/components/Barrage';
import Video from '@/components/Video';
import { doPoint, requestEvent } from '@/utils';

export default {
  name: 'PhysicianDay',
  components: {
    Barrage,
    Video,
  },
  data() {
    return {
      topImage: '', // 头图
      voteImage: '', // 投票图片
      voteUrl: '', // 投票跳转链接
      appointmentImage: '', // 预约直播的图片
      appointmentUrl: '', // 预约直播跳转链接
      playImage: '', // 视频播放图片
      playUrl: '', // 视频url
      speechImage: '', // 致辞图片
      thankWordsList: [], // 感谢词列表
      thankMessage: '', // 祝福词
      isUserLogin: false, // 用户是否登录
    };
  },
  created() {
    this.getDoctorsDayPatientPageDetail();
    doPoint('ActivityPageView', {
      app: this.getApp(),
      activity_name: '医师节H5用户端',
    });
  },
  methods: {
    // 发请求获取页面详情
    async getDoctorsDayPatientPageDetail() {
      try {
        const {
          error_code,
          error_msg,
          data = {},
        } = await doctorsDayPatientPageDetail();
        if (error_code === 0) {
          const {
            top_image = '',
            vote_image = '',
            vote_url = '',
            appointment_image = '',
            appointment_url = '',
            play_image = '',
            play_url = '',
            speech_image = '',
            thank_words_list = [],
          } = data;
          this.topImage = top_image;
          this.voteImage = vote_image;
          this.voteUrl = vote_url;
          this.appointmentImage = appointment_image;
          this.appointmentUrl = appointment_url;
          this.playImage = play_image;
          this.playUrl = play_url;
          this.speechImage = speech_image;
          this.thankWordsList = thank_words_list;
          this.setShare(top_image);
        } else {
          this.toast(error_msg || '获取详情失败');
        }
      } catch (error) {
        this.toast(error.error_msg || '获取详情失败');
      }
    },

    // 点击发表内容
    clickSendBtn() {
      doPoint('ActivityClick', {
        app: this.getApp(),
        activity_name: '医师节H5用户端',
        click_position: '发表感谢',
      }).finally(() => {
        if (this.isUserLogin) {
          this.sendThankMessage();
        } else {
          this.login();
        }
      });
    },

    // 发表感谢词
    async sendThankMessage() {
      if (!this.thankMessage) {
        this.toast('未填写内容');
      } else {
        doctorsDaySendThankWords({
          content: this.thankMessage,
        })
          .then(res => {
            const { error_code, error_msg } = res;
            if (error_code === 0) {
              this.toast('发表成功');
              this.thankMessage = '';
            } else {
              this.toast(error_msg || '发表失败');
            }
          })
          .catch(error => {
            this.toast(error.error_msg || '发表失败');
          });
      }
    },

    // 判断用户是否登录
    login() {
      isLogin()
        .then(res => {
          const { is_login } = res;
          if (!is_login) {
            requestEvent();
          } else {
            this.isUserLogin = true;
            this.sendThankMessage();
          }
        })
        .catch(err => {
          this.toast(err.error_msg || '获取登录结果失败');
        });
    },

    // 视频播放
    playVideo() {
      this.doActivityClick('视频模块');
    },

    // 二次封装click打点
    doActivityClick(click_position, next_url) {
      doPoint('ActivityClick', {
        app: this.getApp(),
        activity_name: '医师节H5用户端',
        click_position,
      }).finally(() => {
        if (next_url) {
          window.location.href = next_url;
        }
      });
    },

    // 二次封装toast
    toast(txt, time = 1000) {
      this.$createToast({
        time,
        txt,
        type: 'txt',
      }).show();
    },

    // 获取用户所处环境
    getApp() {
      if (cyDetect.isFromCY()) {
        return 0;
      }
      if (cyDetect.isFromCYClinic()) {
        return 1;
      }
      return 'weixin_mini';
    },

    // 分享
    setShare(top_image) {
      try {
        const opt = {
          title: '致敬了不起的平凡',
          desc: '「春雨医生819医师节」评选最美医师，了解医生故事',
          img: top_image,
          link: `https://${window.location.host}/v-m-general/physician-day`,
        };
        cyShare.app(opt);
      } catch (error) {
        console.log('share err::', error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@@/styles/mixin.scss';
.physician-day-wrap {
  padding-bottom: rem(58);
  background: #fdf1d8;

  .web-banner {
    width: 100%;
    img {
      display: block;
      width: 100%;
    }
  }

  .vote-wrap {
    width: 100%;
    padding: 0 rem(15);
    img {
      display: block;
      width: 100%;
    }
  }

  .barrage-wrap {
    position: relative;
    box-sizing: border-box;
    height: rem(216);
    margin: rem(10) rem(15) 0;
    background: url('https://resource.chunyu.mobi/@/media/images/2022/08/04/4964/bc6ff9caccd9_w2096_h1293_.png')
      0 0 no-repeat;
    background-size: 100%;
    .input-wrap {
      position: absolute;
      bottom: rem(20);
      left: 50%;
      display: flex;
      justify-content: space-between;
      width: rem(315);
      height: rem(45);
      padding-right: rem(4);
      background: #fff0ed;
      border-radius: 100px;
      transform: translateX(-50%);
      input {
        width: rem(224);
        height: 100%;
        color: #af9d99;
        font-weight: 600;
        font-size: 14px;
        text-indent: rem(14);
        background: none;
        border: 0;
        outline: none;
        @include placeholder {
          color: #af9d99;
          font-size: 12px;
        }
      }
      .bs-btn {
        display: flex;
        align-items: center;
        justify-content: center;
        width: rem(83);
        height: rem(37);
        margin-top: rem(4);
        color: #fff;
        font-weight: 600;
        font-size: 15px;
        background: linear-gradient(180deg, #ff7251, #ff4641);
        border-radius: rem(19);
      }
    }
  }

  .subscribe-live-wrap {
    width: 100%;
    margin-top: rem(10);
    padding: 0 rem(15);
    img {
      display: block;
      width: 100%;
    }
  }

  .speech-wrap {
    width: 100%;
    margin-top: rem(10);
    padding: 0 rem(15);
    img {
      display: block;
      width: 100%;
    }
  }

  .logo {
    width: rem(126);
    height: rem(35);
    margin: rem(33) auto 0;
    background: url('https://staff.chunyu.mobi/@/media/images/2022/07/07/f5a4/f9b7478bfc8a_w506_h140_.png')
      no-repeat;
    background-size: 100%;
  }
}
</style>
